import Vue from 'vue';
import Component from 'vue-class-component';
import { postForm } from '@/utils/CrmHttp';
import { ServiceChargeTypeEnum } from '@/types/crm-enums';
import { Toast, Indicator } from 'mint-ui';

import art from '../../../../static/js/proto/art/Art.js';
import model from '../../../../static/js/proto/Model.js';
import front from '../../../../static/js/proto/CtpFront.js';

@Component({

})
export default class DrawMoney extends Vue {
  /**
   * 提现
   */
  public errorMsg: string = '';
  public hintMsg: boolean = false;
  public setting: SystemSettingModel = {} as any;
  public availablemoney = '0.0';
  public formData = {
    name: '',
    bank: '',
    bankBranch: '',
    bankNo: '',
    money: '',
  };
  // 选择银行卡
  public selectBackCar: any = '';
  public bankCardArr: any[] = [];

  // 选择银行卡
  public handleSelect() {
    this.formData.name = this.selectBackCar.name;
    this.formData.bank = this.selectBackCar.bankName;
    this.formData.bankBranch = this.selectBackCar.branchName;
    this.formData.bankNo = this.selectBackCar.bankNo;
  }
  public handleClickBank() {
    if (!this.bankCardArr.length) {
      Toast({
        position: 'bottom',
        message: '未添加银行卡，无法提现，请到【我的银行卡】中添加银行卡。',
      });
    }
  }

  public handleBankCar() {
    this.$router.push('/bankCar');
  }

  public mounted() {
    // 加载配置
    this.loadSetting();
  }
  public async activated() {
    this.selectBackCar = '';
    if (localStorage.drawMoney) {
      this.formData = JSON.parse(localStorage.drawMoney);
    }
    this.formData.money = '';
    this.loadBank();

    front.autoMount(art.bind(this, this.loadMoney));
  }

  public loadMoney(onFail) {
    model.capital.attach('person', art.bind(this, this.onUpdateCapital));
    model.trader.queryCapital.start();
  }

  public onUpdateCapital(capital) {
    console.log('onUpdateCapital', capital);
    if (capital === undefined) {
      this.availablemoney = '0.0';
      return;
    }
    this.availablemoney = capital.available.toFixed(2);
  }
  public async loadBank() {
    Indicator.open();

    this.bankCardArr = [];
    try {
      const data = await postForm('/api/user-bank/query');

      for (const i of data) {
        this.bankCardArr.push({
          id: i.Id,
          cont: i.BankName + '(' + i.BankNo.substr(i.BankNo.length - 4) + ')',
          bankName: i.BankName,
          bankNo: i.BankNo,
          branchName: i.BranchName,
          name: i.Name,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      Indicator.close();
    }
  }
  public get serviceCharge() {
    switch (this.setting.TransferOutServiceChargeType) {
      case ServiceChargeTypeEnum.Fixed:
        return this.setting.TransferOutServiceCharge + '元';
      case ServiceChargeTypeEnum.Rate:
        return this.setting.TransferOutServiceCharge + '%';
    }
    return '';
  }
  public get serviceChargeMoney() {
    switch (this.setting.TransferOutServiceChargeType) {
      case ServiceChargeTypeEnum.Fixed:
        return this.setting.TransferOutServiceCharge;
      case ServiceChargeTypeEnum.Rate:
        const m = this.setting.TransferOutServiceCharge *
          parseFloat(this.formData.money) / 100;
        if (isNaN(m)) {
          return '0';
        }
        return m.toFixed(2);
    }
    return '';
  }
  public async loadSetting() {
    this.setting = await postForm('/api/system/system-setting');
  }
  public deactivated() {
    model.trader.queryCapital.stop();
  }
  public validForm() {
    if (!this.selectBackCar) {
      this.errorMsg = '请选择银行卡';
      this.hintMsg = true;
      this.vanish();
      return false;
    }
    // ....
    // 验证金额
    let money = parseFloat(this.formData.money);
    money = isNaN(money) ? 0 : money;
    if (money <= 0) {
      this.errorMsg = '请正确填写提现金额';
      this.hintMsg = true;
      this.vanish();
      return false;
    }
    if (money > parseFloat(this.availablemoney)) {
      this.errorMsg = '请正确填写提现金额';
      this.hintMsg = true;
      this.vanish();
      return false;
    }

    if (money <= this.serviceChargeMoney) {
      this.errorMsg = '提现金额应大于手续费';
      this.hintMsg = true;
      this.vanish();
      return false;
    }
    return true;
  }
  // 点击提款
  public async handleSubmit() {
    localStorage.drawMoney = JSON.stringify(this.formData);
    if (!this.validForm()) {
      return;
    }
    try {
      const ret = await postForm('/api/transfer-out/req', {
        TotalMoney: this.formData.money,
        Remark: '',
        Bank: this.formData.bank,
        BankBranch: this.formData.bankBranch,
        Name: this.formData.name,
        BankNo: this.formData.bankNo,
      });
      Toast({
        message: '操作成功',
      });
      this.$router.go(-1);
    } catch (error) {
      console.log(error);
      Toast({
        position: 'bottom',
        message: '失败:' + error.msg,
      });
    }
  }
  public vanish() {
    setTimeout(() => {
      this.hintMsg = false;
    }, 1500);
  }
  // 返回
  public goback() {
    this.$router.go(-1);
  }
}



// WEBPACK FOOTER //
// ./src/views/Person/DrawMoney/DrawMoney.ts